import { render, staticRenderFns } from "./OrganiserDetails.vue?vue&type=template&id=147075c8&scoped=true"
import script from "./OrganiserDetails.vue?vue&type=script&lang=js"
export * from "./OrganiserDetails.vue?vue&type=script&lang=js"
import style0 from "./OrganiserDetails.vue?vue&type=style&index=0&id=147075c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147075c8",
  null
  
)

export default component.exports